"use strict";

import angular from "angular";

require("./group/group.module");
require("./groups-create/accounting-groups.module");
require("./integrations/integrations.module");
require("./batch-import/batch-import.module");
require("./company/company.module");
require("./company-create/company-create.module");
require("./contacts-managment/contacts-managment.module");
require("./custom-variables-indicators-charts/custom-variables-indicators-charts.module");
require("./journey/journey.module");
require("./manager-users/manager-users.module");
require("./my-subscription/my-subscription.module");
require("./nps/nps.module");
require("./overview/accounting-overview.module");
require("./prospect/prospect.module");
require("./reporting-center/reporting-center.module");

angular.module("nucont.accounting", [
    "nucont.shared",
    "nucont.accounting.group",
    "nucont.accounting.groups",
    "nucont.accounting.integrations",
    "nucont.accounting.batchImport",
    "nucont.accounting.company",
    "nucont.accounting.companyCreate",
    "nucont.accounting.contactsManagment",
    "nucont.accounting.customVariablesIndicatorsCharts",
    "nucont.accounting.journey",
    "nucont.accounting.managerUsers",
    "nucont.accounting.mySubscription",
    "nucont.accounting.nps",
    "nucont.accounting.overview",
    "nucont.accounting.prospect",
    "nucont.accounting.reportingCenter"
]);
require("./accounting.routes");
